import type { RouteRecordRaw } from "vue-router";
import { routes as vehicleRoutes } from "@/frontend/pages/hangar/[id]/routes";
import { routes as publicHangarRoutes } from "@/frontend/pages/hangar/[username]/routes";
import { FeatureFlagName } from "@/services/fyApi";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "hangar",
    component: () => import("@/frontend/pages/hangar/index.vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.index",
      primaryAction: true,
      backgroundImage: "bg-5",
    },
  },
  {
    path: "wishlist/",
    name: "hangar-wishlist",
    component: () => import("@/frontend/pages/hangar/wishlist.vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.wishlist",
      primaryAction: true,
      backgroundImage: "bg-5",
    },
  },
  {
    path: "preview/",
    name: "hangar-preview",
    component: () => import("@/frontend/pages/hangar/preview.vue"),
    meta: {
      title: "hangar.preview",
      backgroundImage: "bg-5",
    },
  },
  {
    path: "fleetchart/",
    name: "hangar-fleetchart",
    redirect: {
      name: "hangar",
      query: { fleetchart: "true" },
    },
  },
  {
    path: "transfers/",
    name: "hangar-transfers",
    component: () => import("@/frontend/pages/hangar/transfers.vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.transfers",
      backgroundImage: "bg-5",
      feature: FeatureFlagName.INVENTORY_TRANSFERS,
    },
  },
  {
    // Was a route of its own; the view moved into the query so switching
    // to it keeps the page. The path stays so shared links resolve.
    path: "transfers/outgoing/",
    redirect: (to) => ({
      name: "hangar-transfers",
      params: to.params,
      query: { ...to.query, direction: "outgoing" },
    }),
  },
  {
    path: "inventories/",
    name: "hangar-inventories",
    component: () => import("@/frontend/pages/hangar/inventories/index.vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.inventories",
      backgroundImage: "bg-5",
      feature: FeatureFlagName.HANGAR_INVENTORIES,
    },
  },
  {
    // Was a route of its own; the view moved into the query so switching
    // to it keeps the page. The path stays so shared links resolve.
    path: "transactions/",
    redirect: (to) => ({
      name: "hangar-inventories",
      params: to.params,
      query: { ...to.query, tab: "log" },
    }),
  },
  {
    path: "inventories/:inventory/",
    name: "hangar-inventory",
    component: () =>
      import("@/frontend/pages/hangar/inventories/[inventory].vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.inventories",
      backgroundImage: "bg-5",
      feature: FeatureFlagName.HANGAR_INVENTORIES,
    },
  },
  {
    // Was a route of its own; the view moved into the query so switching
    // to it keeps the page. The path stays so shared links resolve.
    path: "inventories/:inventory/transactions/",
    redirect: (to) => ({
      name: "hangar-inventory",
      params: to.params,
      query: { ...to.query, tab: "log" },
    }),
  },
  {
    path: "inventories/:inventory/items/:item/",
    name: "hangar-inventory-item",
    component: () =>
      import("@/frontend/pages/hangar/inventories/[inventory]/[item].vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.inventories",
      backgroundImage: "bg-5",
      feature: FeatureFlagName.HANGAR_INVENTORIES,
    },
  },
  {
    path: "imports/",
    name: "hangar-imports",
    component: () => import("@/frontend/pages/hangar/imports.vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.imports",
      backgroundImage: "bg-5",
    },
  },
  {
    path: "stats/",
    name: "hangar-stats",
    component: () => import("@/frontend/pages/hangar/stats.vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.stats",
      backgroundImage: "bg-5",
    },
  },
  {
    path: ":username/",
    component: () => import("@/frontend/pages/hangar/[username].vue"),
    children: publicHangarRoutes,
    redirect: { name: publicHangarRoutes[0].name },
  },
  // Outside the vehicle's tab shell on purpose: everything under it becomes a
  // tab, and a single cargo position is a page you drill into rather than a
  // fifth place to stand. Same shape as /hangar/inventories/:inventory/:item.
  {
    path: ":id/cargo/:item/",
    name: "hangar-vehicle-cargo-item",
    component: () => import("@/frontend/pages/hangar/[id]/cargo/[item].vue"),
    meta: {
      needsAuthentication: true,
      title: "hangar.vehicleCargo",
      backgroundImage: "bg-5",
      customTitle: true,
      feature: FeatureFlagName.SHIP_INVENTORIES,
    },
  },
  {
    path: ":id/",
    component: () => import("@/frontend/pages/hangar/[id].vue"),
    children: vehicleRoutes,
    redirect: { name: vehicleRoutes[0].name },
    meta: {
      needsAuthentication: true,
    },
  },
];
